import { ApiFrequency, TransactionDirection, TransactionStatus } from "../../../shared/types/Transaction";

export interface CashieringTransaction {
    isSloaSetup: boolean;
    processDate: string;
    outgoingAmount?: number | string | null;
    incomingAmount?: number | string | null;
    fundsDirection: TransactionDirection;
    isRecurring: boolean;
    txnCode: string;
    frequencyCode: ApiFrequency;
    to1: string;
    to2: string;
    to3: string;
    isViewable: boolean;
    isEditable: boolean;
    isCancelable: boolean;
    isReactivatable: boolean;
    cashieringRqstId: string;
    cashieringRqstSecondId: string;
    mediaTypeCd: string;
    typeDescription: string;
    statusCd: string;
    statusCodeDescription: TransactionStatus;
    bundledSloaIn: boolean;
    thirdPartyInd: boolean;
    faMasterAcct: string;
    address: string;
}

export const isCashieringTransaction = (transaction: any): transaction is CashieringTransaction => {
    return transaction.fundsDirection !== null && transaction.fundsDirection !== undefined;
}